<div class="container">
  <section class="container__info">
    <div class="container__info--width">
      <h1 class="home__title">Precisa de ajuda?</h1>
      <p class="home__subtitle">
        Queremos que o seu negócio cresça cada vez mais. Sempre que precisar de
        ajuda entre em contato através dos nossos canais de atendimento.
        <b>Segunda à sexta, das 8h às 12h, e das 13h às 17h30.</b>
      </p>
      <button
        style="color: #cc3179"
        mat-stroked-button
        onclick="window.open('https://api.whatsapp.com/send/?phone=5547992157013&text&app_absent=1')"
      >
        <img
          width="20px"
          src="../../../assets/img/whatsapp-rosa.png"
          alt="whats"
        />
        Whatsapp
      </button>
    </div>
  </section>

  <section class="container__form">
    <div class="contact">
      <div class="contact__block">
        <mat-icon>mail</mat-icon>
        <div class="space-contacts">
          <p>Podemos te ajudar por email.</p>
          <p style="color: #cc3179">suporte&#64;broadfactor.com</p>
        </div>
      </div>
      <div class="contact__block">
        <mat-icon>call</mat-icon>
        <div class="space-contacts">
          <p>Contato Broadfactor</p>
          <p style="color: #cc3179">(47) 99215-7013</p>
        </div>
      </div>
      <div class="contact__block">
        <img width="24px" src="../../../assets/img/whats.svg" alt="whats" />
        <div class="space-contacts">
          <p>Você pode entrar em contato pelo Whatsapp</p>
          <a
            style="color: #cc3179; font-size: 16px"
            href="https://api.whatsapp.com/send/?phone=5547992157013&text&app_absent=1"
            target="_blank"
            >Whatsapp</a
          >
        </div>
      </div>
      <div class="contact__block">
        <mat-icon>place</mat-icon>
        <div class="space-contacts">
          <p>Localização</p>
          <p style="color: #cc3179">
            Rua Jerônimo Coelho, nº 78, CEP: 89201-050. Joinville (SC)
          </p>
        </div>
      </div>
    </div>
    <div class="form">
      <img src="../../../assets/img/png/fale-conosco.png" alt="" />
    </div>
  </section>
</div>
